"use client";
import React, { useEffect } from "react";
import StickyContainer from "./components/StickyContainer";

interface SpecialSubProductsListBProps {}

const SpecialSubProductsListB: React.FC<SpecialSubProductsListBProps> = (
    props,
) => {
    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
          #quick-chat-iframe {
            display: none !important;
          }
        `;
        document.head.appendChild(style);

        return () => style.remove();
    }, []);
    return (
        <>
            <StickyContainer />
        </>
    );
};

export default SpecialSubProductsListB;
